import React from 'react';

const ImageContainer: React.FC<any> = (props) => {
  const { property } = props;

  return (
    <div
      style={{
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: property.backgroundPosition || 'center center',
        backgroundImage: `url(${property.imageUrl})`,
        width: '100%',
        height: '100%',
      }}
    ></div>
  );
};

export default ImageContainer;
